import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
    name: 'userRole',
    standalone: false
})
export class UserRolePipe implements PipeTransform {

  constructor(private mUserService: UserService) {

  }

  transform(value: string) {
    switch (value) {
      case this.mUserService.userRoles.Admin:
        return 'Администратор';

      case this.mUserService.userRoles.Customer:
        return 'Покупатель';

      default:
        return '';
    }
  }

}
